import FieldControl from 'global/form/FieldControl';
import RadioButtonFieldControl from './RadioButtonFieldControl';

class FormControl {
	constructor(formNode) {
		if (formNode.odFormControlInstance) {
			return formNode.odFormControlInstance;
		}
		formNode.odFormControlInstance = this;

		this.form = formNode;
		this.rules = this.getFormValidationRules();
		this.fields = this.getFormValidationFields();
		this.fields = this.handleRadioButtonSets();
		this.fieldControls = this.initFieldControls();
		this.attachFormEvents();
	}

	getFormValidationRules() {
		const rules = this.form.getAttribute('data-validation-rules') || '{}';
		return JSON.parse(rules);
	}

	getFormValidationFields() {
		const validationFields = [];

		for (let i = 0; i < this.form.elements.length; i += 1) {
			const field = this.form.elements[i];

			if (Object.prototype.hasOwnProperty.call(this.rules, field.name)) {
				validationFields.push(field);
			}
		}

		return validationFields;
	}

	handleRadioButtonSets() {
		const radioButtonSets = {};
		const filteredFields = this.fields.filter(field => {
			if (field.type === 'radio') {
				const { name } = field;
				radioButtonSets[name] = radioButtonSets[name] || [];
				radioButtonSets[name].push(field);
				return false;
			}
			return true;
		});
		return filteredFields.concat(Object.values(radioButtonSets));
	}

	initFieldControls() {
		return this.fields.map(field => this.initFieldControl(field));
	}

	initFieldControl(field) {
		let rules;
		if (Array.isArray(field)) {
			rules = this.rules[field[0].name];
			return new RadioButtonFieldControl(field, rules);
		}
		rules = this.rules[field.name];
		return new FieldControl(field, rules);
	}

	attachFormEvents() {
		this.form.addEventListener('submit', e => this.onSubmit(e));
	}

	isFormValidationEnabled() {
		if (typeof this.form.dataset.validateForm === 'undefined') {
			return true;
		}

		return JSON.parse(this.form.dataset.validateForm);
	}

	isFormValid() {
		return !(this.isFormValidationEnabled() && !this.validateForm());
	}

	onSubmit(e) {
		if (!this.isFormValid()) {
			e.preventDefault();
			return false;
		}
		return true;
	}

	validateForm() {
		const fieldsToValidate = this.getFieldsToValidate();
		return this.validateFields(fieldsToValidate);
	}

	getFieldsToValidate() {
		const specificFieldsStr = this.form.getAttribute(
			'data-validate-specific-fields',
		);
		if (specificFieldsStr) {
			const specificFieldNames = specificFieldsStr.split('|');
			return this.fieldControls.filter(fieldControl =>
				specificFieldNames.includes(fieldControl.getFieldName()),
			);
		}

		return this.fieldControls;
	}

	validateFields(fieldControls) {
		const invalidFields = fieldControls.filter(
			fieldControl => !fieldControl.validateField(),
		);
		return invalidFields.length === 0;
	}
}

export default FormControl;
